export default {
  methods: {
    async closeAndTo(routerName, params, query = { reload: true }) {
      this.$store.commit('removeViewTags', this.$route)
      this.$store.commit('removeKeepLive', this.$route.name)
      this.$router.push({
        name: routerName,
        params,
        query,
      })
    },
  },
}
